// Lib
import React from 'react';

// Components
import ElementTool from './ElementTool';
import RequireElementTypeEditPermission from './RequireElementTypeEditPermission';
import Icon from '../../../../components/icons/Icon';

// Utils
import randomString from '../../../../../common/uid/randomString';
import { isFeatureEnabled } from '../../../../../common/users/utils/userPropertyUtils';

// Constants
import { HEADER_CARD_DISPLAY_NAME } from '../../../../../common/cards/cardConstants';

import { BLOCK_METADATA } from '../../../../components/editor/richText/richTextConstants';
import { ExperimentId } from '../../../../../common/experiments/experimentsConstants';
import { ElementToolSettings, ToolbarItemConfig } from '../../toolbarTypes';
import { ImMNCurrentUser } from '../../../../user/currentUserSelector';

const getHeaderDefaultContent = (shouldUseTiptapContent: boolean) => () => {
    if (shouldUseTiptapContent) {
        return {
            textContent: {
                type: 'doc',
                content: [
                    {
                        type: 'heading',
                        attrs: {
                            key: randomString(5),
                            textAlign: 'center',
                            level: 1,
                        },
                    },
                ],
            },
            background: null,
            transparent: {
                enabled: true,
            },
        };
    }

    return {
        textContent: {
            blocks: [
                {
                    key: randomString(5),
                    text: '',
                    type: 'header-one',
                    depth: 0,
                    inlineStyleRanges: [],
                    entityRanges: [],
                    data: {
                        [BLOCK_METADATA.TEXT_ALIGN_CENTER]: true,
                        [BLOCK_METADATA.HEADER_TITLE]: true,
                        // Treats this block as if it is unstyled when delete key is pressed & block is empty
                        [BLOCK_METADATA.IGNORE_FOR_DELETE]: true,
                    },
                },
            ],
            entityMap: {},
        },
        transparent: {
            enabled: true,
        },
    };
};

type HeaderToolProps = {
    toolName: string;
    currentUser: ImMNCurrentUser;
    currentBoardId: string;
    item: ToolbarItemConfig;
    elementTypeObject: any;
    gridSize: number;
    selectOnCreate: boolean;
    editOnCreate: boolean;
    currentUserId: string;
    permissions: number;
    suggestedColors: string[];
};

const HeaderTool = (props: HeaderToolProps) => {
    const {
        toolName,
        item,
        currentBoardId,
        gridSize,
        selectOnCreate,
        editOnCreate,
        currentUserId,
        currentUser,
        permissions,
    } = props;

    const toolSettings = item?.toolSettings as ElementToolSettings | undefined;
    const elementTypeObject = toolSettings?.elementTypeObject || props.elementTypeObject || {};

    const shouldUseTiptapContent = isFeatureEnabled(ExperimentId.tiptapConversion, currentUser);

    return (
        <RequireElementTypeEditPermission elementType={elementTypeObject.elementType} permissions={permissions}>
            <ElementTool
                name={HEADER_CARD_DISPLAY_NAME}
                toolName={toolName}
                elementType={elementTypeObject.elementType}
                currentBoardId={currentBoardId}
                currentUserId={currentUserId}
                gridSize={gridSize}
                editOnCreate={editOnCreate}
                selectOnCreate={selectOnCreate}
                icon={<Icon name="element-header" gridSize={gridSize} />}
                getDefaultContent={getHeaderDefaultContent(shouldUseTiptapContent)}
            />
        </RequireElementTypeEditPermission>
    );
};

export default HeaderTool;
